<template>
  <div id="parallax">
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="tagline col-md-1">
            <slot name="tagline-left"></slot>
          </div>
          <div class="col-md-11 parallax-fade-top">
            <slot name="heading"></slot>
          </div>
          <div class="tagline col-md-1">
            <slot name="tagline-right"></slot>
          </div>
          <div class="offset-2 col-10 parallax-fade-top mt-2 mt-sm-3">
            <slot name="sub-heading"></slot>
          </div>
          <div class="offset-md-2 col-md-10 parallax-fade-top mt-2 mt-sm-3">
            <slot name="link"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ParallaxEffect } from "@/components/utils";

export default {
  mounted() {
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped></style>
